import isAbsoluteURL from "../externals/axios/helpers/isAbsoluteURL";
export var normalize = function (url) {
    if (!url) {
        return '';
    }
    if (isAbsoluteURL(url)) {
        var reg = /(^([a-z][a-z\d\+\-\.]*:)?\/{2,}[^\/]+)\/{1}(.+)/i;
        var res_1 = reg.exec(url);
        if (res_1) {
            var origin_1 = res_1[1] || '';
            var pathname = res_1[3] || '';
            var normalizedPath_1 = normalize(pathname);
            return (origin_1.replace(/\/$/, "") + "/" + normalizedPath_1.replace(/^\//, ""));
        }
    }
    var res = url.split('?');
    var pathName = res[0] || '';
    var normalizedPath = pathName
        .replace(/\.+/g, '')
        .replace(/\/{2,}/g, '/')
        .replace(/\/$/, '');
    res[0] = normalizedPath;
    return res.join('?');
};
export default normalize;
//# sourceMappingURL=normalize.js.map